import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * MustChangePasswordGuard (Iter307.3)
 *
 * Redireciona qualquer usuário logado cujo `user.must_change_password`
 * seja `true` para `/conta/mudar-senha`. Fica montado no topo do
 * `<AppRouter>`, imediatamente antes das `<Routes>`, para funcionar
 * como middleware client-side.
 *
 * Exceções (não redireciona nessas rotas para não gerar loop):
 *   - `/conta/mudar-senha` — a própria página de troca
 *   - `/conta`             — permite logout se o professor preferir
 *
 * O backend continua sendo a fonte da verdade: mesmo se um usuário
 * conseguir contornar o guard client-side, todas as rotas protegidas
 * continuam funcionando (o must_change_password é apenas soft-block
 * de UX). Endurecimento server-side pode ser adicionado em iteração
 * futura via dependency que rejeite operações de escrita quando a
 * flag estiver ativa.
 */
const ALLOWED_PATHS = new Set(["/conta/mudar-senha", "/conta"]);

export default function MustChangePasswordGuard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user || typeof user !== "object") return;
    if (!user.must_change_password) return;
    if (ALLOWED_PATHS.has(location.pathname)) return;
    navigate("/conta/mudar-senha", {
      replace: true,
      state: { from: location.pathname },
    });
  }, [user, location.pathname, navigate]);

  return null;
}
